import Moment from 'moment'

export default {
  /***
   * Util function for validation. Returns true if the date range for the two parameters is a valid one.
   * The parameters can be anything parseable by moment (including moment objects themselves.)
   * @returns {false|*|boolean}
   * @param startDate
   * @param endDate
   */
  dateRangeIsValid (startDate, endDate) {
    if (startDate == null && endDate == null) {
      return false
    }
    const start = Moment(startDate)
    const end = Moment(endDate)
    return start.isValid() && end.isValid() && end >= start
  }
}
